import { Flex, TextField, Button, Box } from '@radix-ui/themes';

type Props = {
  inputValue: string;
  onInputValueChange: (value: string) => void;
  onSubmit: () => void;
  isDisabled?: boolean;
  isLoading?: boolean;
};

export default function ChatInput({
  inputValue,
  onInputValueChange,
  onSubmit,
  isDisabled,
  isLoading,
}: Props) {
  return (
    <Flex direction="row" width="100%" gap="4" mt="2" className="chat-input-row">
      <Box className="chat-input-field">
        <TextField.Root
          className="fullwidth chat-input-control"
          size="3"
          placeholder="e.g. I have a wine shop"
          value={inputValue}
          onChange={(e) => onInputValueChange(e.currentTarget.value)}
          onKeyDown={(e) => { if (e.key === 'Enter' && !isDisabled) { onSubmit(); } }}
        />
      </Box>
      <Box className="chat-input-submit">
        <Button size="3" onClick={onSubmit} disabled={isDisabled} loading={isLoading} className="fullwidth chat-submit-button">
          →
        </Button>
      </Box>
    </Flex>
  );
}
